/** Every tag this module adds carries this attribute, so it can be found and replaced later. */
const MANAGED_ATTRIBUTE = 'data-seo';

export interface HeadTag {
  tag: 'meta' | 'link' | 'script';
  attrs: Record<string, string>;
  /** Text content (used for JSON-LD scripts). */
  text?: string;
}

function removeManagedTags(): void {
  document.head.querySelectorAll(`[${MANAGED_ATTRIBUTE}]`).forEach((element) => element.remove());
}

/** Replaces the page title and every previously managed head tag with the given set. */
export function applyHead(title: string, tags: HeadTag[]): void {
  document.title = title;
  removeManagedTags();

  const fragment = document.createDocumentFragment();
  tags.forEach(({ tag, attrs, text }) => {
    const element = document.createElement(tag);
    Object.entries(attrs).forEach(([name, value]) => element.setAttribute(name, value));
    if (text) element.textContent = text;
    element.setAttribute(MANAGED_ATTRIBUTE, '');
    fragment.appendChild(element);
  });
  document.head.appendChild(fragment);
}

/** Removes managed tags and restores a neutral title (used when a page unmounts). */
export function resetHead(defaultTitle: string): void {
  removeManagedTags();
  document.title = defaultTitle;
}
